import { GetterTree } from 'vuex'

import isPostcodeFrom from '@/helpers/isPostcodeFrom'

import { RootState, SupportedLanguages } from './types'

const getters: GetterTree<RootState, RootState> = {
  translation:
    state =>
    (key, plural = false): string => {
      const term = state.translations[key]

      if (!term) {
        return ''
      }

      if (typeof term === 'string') {
        return term
      }

      if (plural && term.other) {
        return term.other
      }

      if (term.one) {
        return term.one
      }
    },

  chosenLanguage: state =>
    (localStorage.getItem('language_code') as SupportedLanguages) ||
    state.chosenLanguage,

  hasBerlinAddress: state =>
    isPostcodeFrom.berlin(
      state.carereceiver.carereceiverProfilePageData.postcode,
    ) || isPostcodeFrom.berlin(state.payment.paymentPageData.postcode),
}

export default getters
